import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CartVoucherService } from '@spartacus/cart/base/core';
import { ActiveCartFacade, Cart } from '@spartacus/cart/base/root';
import { CustomerCoupon, CustomerCouponService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { CustomValidateCartService } from '../../../../../services/cart/validate-cart.service';

@Component({
  selector: 'app-cart-coupon',
  templateUrl: './custom-cart-coupon.component.html',
  standalone: false
})
export class CustomCartCouponComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  MAX_CUSTOMER_COUPON_PAGE = 100;
  couponForm: UntypedFormGroup;
  cartIsLoading$: Observable<boolean>;
  cartId: string;
  applicableCoupons: CustomerCoupon[];
  @Input() cart;

  protected ignoreCloseEvent = false;

  couponBoxIsActive = false;

  constructor(
    protected cartVoucherService: CartVoucherService,
    protected formBuilder: UntypedFormBuilder,
    protected customerCouponService: CustomerCouponService,
    protected activeCartService: ActiveCartFacade,
    protected validateCart: CustomValidateCartService,
  ) {
  }

  ngOnInit(): void {
    this.subscriptions.add(this.validateCart.getProductsModifiedLoading().subscribe(success => {
      if (!success) {
        if (this.customerCouponService) {
          this.customerCouponService.loadCustomerCoupons(
            this.MAX_CUSTOMER_COUPON_PAGE
          );
        }

        this.couponForm = this.formBuilder.group({
          couponCode: ['', [Validators.required]],
        });
      }
    }));
  }

  protected onError(error: boolean): void {
    if (error) {
      this.customerCouponService.loadCustomerCoupons(
        this.MAX_CUSTOMER_COUPON_PAGE
      );
    }
  }

  onSuccess(success: boolean): void {
    if (success) {
      this.couponForm.reset();
    }
  }

  protected getApplicableCustomerCoupons(
    cart: Cart,
    coupons: CustomerCoupon[]
  ): void {
    this.applicableCoupons = coupons || [];
    if (cart.appliedVouchers) {
      cart.appliedVouchers.forEach((appliedVoucher) => {
        this.applicableCoupons = this.applicableCoupons.filter(
          (coupon) => coupon.couponId !== appliedVoucher.code
        );
      });
    }
  }

  applyVoucher(): void {
    if (this.couponForm.valid) {
      this.cartVoucherService.addVoucher(
        this.couponForm.value.couponCode,
        this.cartId
      );
    } else {
      this.couponForm.markAllAsTouched();
    }
  }

  applyCustomerCoupon(couponId: string): void {
    this.cartVoucherService.addVoucher(couponId, this.cartId);
    this.couponBoxIsActive = false;
  }

  close(event: UIEvent): void {
    if (!this.ignoreCloseEvent) {
      this.couponBoxIsActive = false;
      if (event && event.target) {
        (event.target as HTMLElement).blur();
      }
    }
    this.ignoreCloseEvent = false;
  }

  disableClose(): void {
    this.ignoreCloseEvent = true;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
